import { maxScope } from '@/constants/strava'
import { ProvidedStravaScope } from '@/enums/provided-strava-scope'

class StravaHelperService {
  constructor() {}

  public authPage(forceApprovalPrompt: 'force' | 'auto' = 'force'): string {
    const clientID = import.meta.env.VITE_STRAVA_CLIENT_ID
    const responseType = 'code'
    const redirectURL = import.meta.env.VITE_STRAVA_REDIRECT_URL
    const approvalPrompt = forceApprovalPrompt
    const authPageUrl = `http://www.strava.com/oauth/authorize?client_id=${clientID}&response_type=${responseType}&redirect_uri=${redirectURL}&approval_prompt=${approvalPrompt}&scope=${maxScope}`
    return authPageUrl
  }

  public checkProvidedScope(currentScope: string): ProvidedStravaScope {
    const maxScopeSeparated = maxScope.split(',')
    const currentScopeSeparated = currentScope.split(',')

    const wasMaxScopeProvided = this.checkForIdenticalScopes(
      currentScopeSeparated,
      maxScopeSeparated
    )
    if (wasMaxScopeProvided) {
      return ProvidedStravaScope.MAX
    }

    return ProvidedStravaScope.INSUFFICIENT
  }

  private checkForIdenticalScopes(arr1: string[], arr2: string[]): boolean {
    return (
      new Set(arr1).size === new Set(arr2).size &&
      new Set(arr1).size === new Set([...arr1, ...arr2]).size
    )
  }
}
export default new StravaHelperService()
